// src/native/components/google-calendar-item.jsx

import React from 'react'
import {
  ListItem,
} from 'react-toolbox/lib/list'
import googleCalendarListTheme from './themes/google-calendar-list.css'
import moment from 'moment'

const MAX_COUNT = 60

class GoogleCalendarItem extends React.Component {
    displayDescription = (desc) => {
      if (!desc || desc.length == 0)
        return null
      const rowDesc = desc.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
                .replace(/^[ \t\n\r\f]+|\s+$/g, '')
      if(desc.length > MAX_COUNT)
        return rowDesc.slice(0, MAX_COUNT) + '...'
      else 
        return rowDesc
    }

    setCaption = (event, checkedTime) => {
      //日跨ぎ判定
      const isStraddleTheDay = event && moment(event.startTime).format('YYYY-MM-DD') != moment(event.endTime).format('YYYY-MM-DD') ? true : false
      if(isStraddleTheDay){
        return (
          <div>
            {checkedTime && `${moment(event.startTime).format('MMMDo(dd) HH:mm')} ~ ${moment(event.endTime).format('MMMDo(dd) HH:mm')}`} {event.title}
          </div>
        )
      } else {
        if(event.startTime)
          return (
            <div>
              {checkedTime && `${moment(event.startTime).format('HH:mm')} - ${moment(event.endTime).format('HH:mm')}`} {event.title}
            </div>
          )
        else if(event.date && event.endDate)
          return (
            <div>
              {checkedTime && this.props.t('label:終日')} {event.title}
            </div>
          )
      }
    }

    render() {
      const {
        t,
        id,
        event,
        checked,
        checkedTime,
      } = this.props

      const showDescription = event.description && checked

      return <ListItem ripple={false}
            theme={googleCalendarListTheme}
            caption={this.setCaption(event, checkedTime)}
            legend={showDescription ? this.displayDescription(event.description) : null} />
    }
  }

  export default GoogleCalendarItem


// WEBPACK FOOTER //
// ./src/web/components/google-calendar-item.jsx